module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-sn.e2187199.png";